"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _Tabs = _interopRequireDefault(require("@mui/material/Tabs"));
var _Tab = _interopRequireDefault(require("@mui/material/Tab"));
var _theme = _interopRequireWildcard(require("../../theme"));
var Theme = _theme;
var _ArrowBackRounded = _interopRequireDefault(require("@mui/icons-material/ArrowBackRounded"));
var _Text = _interopRequireDefault(require("../../components/Text"));
var _Button = _interopRequireDefault(require("../../components/Button"));
var _Bubble = _interopRequireDefault(require("../../components/Bubble"));
var _TextInput = _interopRequireDefault(require("../../components/TextFields/TextInput"));
var _PricingDesignForm = _interopRequireDefault(require("./PricingDesignForm"));
var _Revisions = _interopRequireDefault(require("./Revisions"));
var _helpers = require("../../services/helpers");
var _NumberInput = _interopRequireDefault(require("../../components/TextFields/NumberInput"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Loader = _interopRequireDefault(require("../../components/Loader"));
var Services = _interopRequireWildcard(require("../../services"));
var _FormModal = _interopRequireDefault(require("../../components/Modals/FormModal"));
var _DateInput = _interopRequireDefault(require("../../components/TextFields/DateInput"));
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ClassPricingContainer = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(ClassPricingContainer, _PureComponent);
  function ClassPricingContainer() {
    var _this;
    (0, _classCallCheck2["default"])(this, ClassPricingContainer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, ClassPricingContainer, [].concat(args)), _this.state = {
      value: 0,
      designIDs: _this.props.designs[_this.props.selectedClassID] ? Object.keys(_this.props.designs[_this.props.selectedClassID]) : [],
      selectedDesignID: null,
      showPricingForm: false,
      telusDrugPlanID: null,
      showPastPricing: false,
      drugPlanIDs: [],
      coverages: {
        solo: 0,
        duo: 0,
        family: 0
      }
    }, _this._handleCoveragesChange = function (type, amount) {
      _this.setState({
        coverages: _objectSpread(_objectSpread({}, _this.state.coverages), {}, (0, _defineProperty2["default"])({}, type, amount))
      });
    }, _this._saveCoverages = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var soloCoverageError, duoCoverageError, familyCoverageError;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Services.validateInput('checkEmpty', _this.state.coverages.solo);
          case 2:
            soloCoverageError = _context.sent;
            _context.next = 5;
            return Services.validateInput('checkEmpty', _this.state.coverages.duo);
          case 5:
            duoCoverageError = _context.sent;
            _context.next = 8;
            return Services.validateInput('checkEmpty', _this.state.coverages.family);
          case 8:
            familyCoverageError = _context.sent;
            _this.setState({
              soloCoverageError: soloCoverageError,
              duoCoverageError: duoCoverageError,
              familyCoverageError: familyCoverageError
            });
            if (!(soloCoverageError || duoCoverageError || familyCoverageError)) {
              _context.next = 12;
              break;
            }
            return _context.abrupt("return");
          case 12:
            _this.props.saveCoverages(_this.props.selectedClassID, _this.state.coverages);
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })), _this._handleTabChange = function (event, value) {
      var design = _this.props.designs[_this.props.selectedClassID][_this.state.designIDs[value]];
      _this.setState({
        value: value,
        selectedDesignID: _this.state.designIDs[value],
        telusDrugPlanID: design.telusDrugPlanID || null
      });
      var designPricing = design.pricing.bare || design.pricing; // TODO: change this to just design.pricing once all pricing has been udpdated

      if (!isNaN(designPricing.drugs.solo)) {
        _this.setState({
          showPricingForm: true
        });
      }
    }, _this._handleDrugPlanIDChange = function (e) {
      var value = e.target.value;
      _this.setState({
        telusDrugPlanID: value
      });
      _this.props.saveTelusDrugPlanID(value, _this.state.selectedDesignID, _this.props.selectedClassID);
    }, _this._toggleRevisions = function () {
      _this.setState({
        showingRevisions: !_this.state.showingRevisions
      });
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _createClass2["default"])(ClassPricingContainer, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var design, drugPlanIDs, readyData, coverages, designPricing;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              design = this.props.designs[this.props.selectedClassID][this.state.designIDs[0]];
              _context2.next = 3;
              return (0, _helpers.fetchTelusDrugIDs)();
            case 3:
              drugPlanIDs = _context2.sent;
              readyData = drugPlanIDs.map(function (row) {
                return row.DrugPlanIDs;
              });
              coverages = this.state.coverages;
              if (this.props.quote) {
                coverages = {
                  solo: this.props.quote.classes[this.props.selectedClassID].coverages.solo,
                  duo: this.props.quote.classes[this.props.selectedClassID].coverages.duo,
                  family: this.props.quote.classes[this.props.selectedClassID].coverages.family
                };
              }
              this.setState({
                selectedDesignID: this.state.designIDs[0],
                telusDrugPlanID: design.telusDrugPlanID || null,
                drugPlanIDs: readyData,
                coverages: coverages
              });
              designPricing = design.pricing.bare || design.pricing; // TODO: change this to just design.pricing once all pricing has been udpdated
              if (!isNaN(designPricing.drugs.solo)) {
                this.setState({
                  showPricingForm: true
                });
              }
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        designs = _this$props.designs,
        selectedClassID = _this$props.selectedClassID,
        selectedClass = _this$props.selectedClass;
      var _this$state = this.state,
        selectedDesignID = _this$state.selectedDesignID,
        drugPlanIDs = _this$state.drugPlanIDs;
      var styles = {
        container: _theme.globalStyles.containerControlSite,
        content: _theme.globalStyles.content,
        contentBlock: _theme.globalStyles.contentBlock,
        tabSelected: _theme.globalStyles.tabSelected,
        tabsIndicator: _theme.globalStyles.tabsIndicator,
        saveBtn: {
          display: 'block',
          marginLeft: 'auto',
          marginTop: "20px !important"
        },
        header: {
          display: 'flex',
          flex: 1,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: "space-between"
        },
        headerTitleBlock: {
          display: 'flex',
          flex: 1,
          flexDirection: 'row',
          alignItems: 'center'
        },
        // newButton: {
        //     padding: 0,
        //     fontSize: 12,
        //     color: theme.palette.primary.main
        // },
        // plusIcon: {
        //     color: theme.palette.primary.main,
        //     fontSize: 16,
        //     padding: 0
        // },
        pricingBlock: {
          border: "1.5px solid #F1F1F1",
          paddingLeft: 30,
          paddingRight: 30,
          borderRadius: 5,
          marginTop: 20
        },
        pricingBlockHeader: {
          display: 'flex',
          flex: 1,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: "space-between"
        },
        block: {
          border: "1.5px solid #F1F1F1",
          paddingLeft: 30,
          paddingRight: 30,
          borderRadius: 5,
          marginTop: 20
        },
        headerBorder: {
          borderBottom: "1.5px solid #F1F1F1"
        },
        tabsRoot: {
          // borderBottom: `1px solid ${ Theme.colors.borderGrey }`
        },
        tabRoot: {
          "&.MuiTab-root": {
            fontFamily: "AvenirLTPro-Medium",
            color: Theme.colors.mainTextGrey,
            textTransform: 'capitalize',
            minWidth: '160px'
          },
          "&.MuiTab-root.Mui-selected": {
            color: Theme.colors.skyBlue
          }
        }
      };
      if (!selectedDesignID || this.state.drugPlanIDs.length === 0) {
        return /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
          whitelabel: this.props.whitelabel
        });
      }
      if (this.state.showingRevisions) {
        return /*#__PURE__*/_react["default"].createElement(_Revisions["default"], {
          selectedClassID: selectedClassID,
          selectedDesignID: this.state.selectedDesignID,
          accountID: this.props.currentAccountMeta.accountID,
          commissions: this.props.commissions,
          designs: designs,
          pricing: designs[selectedClassID][this.state.selectedDesignID].pricing,
          getPricingRevisions: this.props.getPricingRevisions,
          getSinglePricingRevision: this.props.getSinglePricingRevision,
          goBack: this._toggleRevisions
        });
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.contentBlock
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.header
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.headerTitleBlock
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        customStyle: styles.backBtn,
        onClick: this.props.goBack,
        transparent: true
      }, /*#__PURE__*/_react["default"].createElement(_ArrowBackRounded["default"], null)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        extraLarge: true,
        bold: true,
        display: "block",
        margin: "20px 0"
      }, "Plan Pricing")), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        color: "white",
        noHover: true,
        customStyle: {
          height: 50,
          width: 180,
          marginRight: "10px",
          textTransform: "capitalize",
          fontSize: 16
        },
        onClick: this._toggleRevisions
      }, "View Revisions"), /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
        label: "Class: ".concat(selectedClass.title),
        isSelected: true,
        clickable: false
      })), !designs[selectedClassID] || Object.keys(designs[selectedClassID]).length === 0 ? /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true
      }, "The advisor has not created any plan designs yet for this class. Please check with the Advisor or come back later.") : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.props.quote && /*#__PURE__*/_react["default"].createElement("div", {
        style: _objectSpread({
          paddingBottom: 20,
          marginBottom: 30
        }, styles.pricingBlock)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.headerBorder
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        large: true,
        display: "block",
        margin: "20px 0 10px 0",
        color: Theme.colors.skyBlue
      }, "Class Coverage Types")), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        margin: "10px 0 0 0"
      }, "Please provide the number of Solo, Duo and Family members for this class. We will use these values to drive the pricing breakdown for the Advisor."), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 3
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: "# Solo Members",
        fullWidth: true,
        variant: "outlined",
        value: this.state.coverages.solo,
        onChange: function onChange(e) {
          return _this2._handleCoveragesChange('solo', e.target.value);
        },
        error: this.state.soloCoverageError
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 3
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: "# Duo Members",
        fullWidth: true,
        variant: "outlined",
        value: this.state.coverages.duo,
        onChange: function onChange(e) {
          return _this2._handleCoveragesChange('duo', e.target.value);
        },
        error: this.state.duoCoverageError
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 3
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: "# Family Members",
        fullWidth: true,
        variant: "outlined",
        value: this.state.coverages.family,
        onChange: function onChange(e) {
          return _this2._handleCoveragesChange('family', e.target.value);
        },
        error: this.state.familyCoverageError
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 3
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: this._saveCoverages,
        color: "primary",
        customStyle: {
          height: 50,
          width: 180,
          textTransform: "capitalize",
          fontSize: 16
        }
      }, "Save Coverages")))), /*#__PURE__*/_react["default"].createElement(_Tabs["default"], {
        value: this.state.value,
        onChange: this._handleTabChange,
        indicatorColor: "primary",
        textColor: "primary",
        sx: _objectSpread({}, styles.tab)
      }, Object.keys(designs[selectedClassID]).map(function (designID, i) {
        var design = designs[selectedClassID][designID];
        return /*#__PURE__*/_react["default"].createElement(_Tab["default"], {
          key: "".concat(design.title, "-").concat(i),
          label: designID === selectedClass.planDesignID ? "".concat(design.title, " (Active)") : design.title,
          sx: _objectSpread({}, styles.tabRoot)
        });
      })), /*#__PURE__*/_react["default"].createElement("div", {
        style: _objectSpread({
          paddingBottom: 20
        }, styles.pricingBlock)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.headerBorder
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        large: true,
        display: "block",
        margin: "20px 0 10px 0",
        color: Theme.colors.skyBlue
      }, "Telus Drug Plan")), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        margin: "10px 0 0 0"
      }, "Please provide the Telus Drug Plan ID for this plan design. You can locate the different options in Telus AdjudiCare."), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: "Telus Drug Plan ID",
        value: this.state.telusDrugPlanID || '',
        onChange: this._handleDrugPlanIDChange,
        select: true,
        fullWidth: true,
        variant: "outlined",
        selectOptions: window.location.hostname.includes('staging') || window.location.hostname.includes('localhost') ? ['12734'] : drugPlanIDs
      })), /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.pricingBlock
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: _objectSpread(_objectSpread({}, styles.header), this.state.showPricingForm ? styles.headerBorder : {})
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        large: true,
        display: "block",
        margin: "20px 0",
        color: Theme.colors.skyBlue
      }, "Pricing"), this.props.quote && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: function onClick() {
          return _this2.setState({
            showPastPricing: !_this2.state.showPastPricing
          });
        },
        color: "primary",
        marginTop: "40px",
        marginBottom: "40px"
      }, "Toggle Past Rates")), /*#__PURE__*/_react["default"].createElement(_PricingDesignForm["default"], {
        classID: selectedClassID,
        designID: this.state.selectedDesignID,
        classData: this.props.classData,
        designs: this.props.designs,
        commissions: this.props.commissions,
        accountID: this.props.currentAccountMeta.accountID,
        pricing: designs[selectedClassID][this.state.selectedDesignID].pricing,
        savePricing: this.props.savePricing,
        savePricingInput: this.props.savePricingInput,
        quote: this.props.quote,
        isQuote: this.props.isQuote,
        isRevision: this.props.isRevision,
        showPastPricing: this.state.showPastPricing,
        loading: this.props.loading
      }))), this.props.loading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
        whitelabel: this.props.whitelabel
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var designIDs = props.designs[props.selectedClassID] ? Object.keys(props.designs[props.selectedClassID]) : [];
      if (designIDs.length !== state.designIDs.length) {
        return {
          designIDs: designIDs,
          value: designIDs.length - 1,
          selectedDesignID: designIDs[designIDs.length - 1],
          telusDrugPlanID: null
        };
      }
      return null;
    }

    /**
     * @param type
     * @param amount
     * @private
     */
  }]);
  return ClassPricingContainer;
}(_react.PureComponent);
var _default = exports["default"] = ClassPricingContainer;